import { render, staticRenderFns } from "./InputTime.vue?vue&type=template&id=352c5336&"
import script from "./InputTime.vue?vue&type=script&lang=js&"
export * from "./InputTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports